<template>
  <v-theme-provider dark>
    <section
      id="post"
      class="mb-10"
    >
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
        >
          <section
            id="hero-alt"
          >
            <base-img
              :height="$vuetify.breakpoint.mdAndUp ? 425 : 225"
              gradient="to bottom, rgba(0,0,0,.2), rgba(0,0,0,.8)"
              max-width="100%"
              :src="firstItem.image_filename"
              color="#45516b"
              flat
              tileimg
            >
              <v-row
                v-if="firstItem.title"
                align="end"
                class="ma-0 fill-height"
                justify="center"
              >
                <v-col
                  class="header-container"
                  cols="12"
                >
                  <base-heading
                    :subtitle="firstItem.subtitle"
                    align="left"
                    space="2"
                    weight="500"
                    v-html="firstItem.title"
                  />
                  <v-subheader
                    class="page-subheader mt-6 mb-12 d-none d-md-flex"
                    v-html="firstItem.subtitle"
                  />
                </v-col>
              </v-row>
            </base-img>
          </section>
        </v-col>
      </v-row>
      <v-container>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            :class="$vuetify.breakpoint.xs ? 'mt-2 blog-body' : 'mt-15 blog-body'"
          >
            <!-- {{ firstItem.image }} -->
            <span v-html="firstItem.body" />
            <p
              class="post-footer py-3 mt-10"
            >
              Posted:
              {{ firstItem.post_date.slice(0,-13) }}
            </p>
          </v-col>
          <v-col
            cols="12"
            :class="$vuetify.breakpoint.xs ? 'mt-0 post-sidebar' : 'mt-15 post-sidebar'"
          >
            <div
              class="social-container mt-3"
            >
              <v-btn
                class="mx-2 btn-printer"
                fab
                dark
                small
                color="#3c3c3c"
                @click="printme"
              >
                <v-icon dark>
                  mdi-printer
                </v-icon>
              </v-btn>
              <v-speed-dial
                v-model="dialShare"
                absolute
                top
                left
                direction="right"
              >
                <!-- open-on-hover -->
                <template v-slot:activator>
                  <v-btn
                    fab
                    bottom
                    small
                    color="primary"
                  >
                    <v-icon
                      v-if="dialShare"
                    >
                      mdi-close
                    </v-icon>
                    <v-icon
                      v-else
                    >
                      mdi-share-variant
                    </v-icon>
                  </v-btn>
                </template>
                <v-btn
                  dark
                  fab
                  bottom
                  color="blue darken-7"
                  small
                  :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`"
                  target="_blank"
                >
                  <v-icon>
                    mdi-linkedin
                  </v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  bottom
                  color="blue"
                  small
                  :href="`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`"
                  target="_blank"
                >
                  <v-icon>
                    mdi-facebook
                  </v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  bottom
                  color="green"
                  small
                  :href="`https://wa.me/?text=Honely%20Insight%20${pageUrl}`"
                  target="_blank"
                >
                  <v-icon>
                    mdi-whatsapp
                  </v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  bottom
                  color="tertiary"
                  small
                  :href="`mailto:?subject=Honely%20Insight&amp;body=${pageUrl}`"
                  target="_blank"
                >
                  <v-icon>
                    mdi-email
                  </v-icon>
                </v-btn>
              </v-speed-dial>
            </div>
            <h3>
              Recent Posts
            </h3>
            <div class="recent-posts-container">
              <v-col
                v-for="item in filteredItems"
                :key="item.id"
                md="4"
                class="mb-5 recent-posts"
              >
                <v-card
                  :to="'/insights' + item.path"
                  class="mx-auto rounded-lg standard-insight"
                  max-width="400"
                  min-height="365"
                  elevation="4"
                >
                <v-img
                  :src="item.image_filename"
                  height="200px"
                />

                <div
                  class="insight-content"
                >
                  <v-card-subtitle>
                    Posted: {{ item.post_date.slice(0,-13) }}
                  </v-card-subtitle>
                  <v-card-title>
                    {{ item.title }}
                  </v-card-title>
                </div>
              </v-card>
            </v-col>
          </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-theme-provider>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SectionInsights',

    metaInfo () {
      return {
        title: this.title,
      }
    },

    data: () => ({
      year: null,
      month: null,
      day: null,
      slug: null,
      loading: false,
      title: null,
      subtitle: null,
      body: null,
      image: null,
      copy: null,
      dialShare: false,
      // pageUrl: 'https://honely.com/insights/',
    }),

    computed: {
      ...mapGetters('insights', {
        // posts: 'allPosts',
        posts: 'targetPosts',
      }),
      firstItem () {
        // if (this.slug === 'did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer') {
        //   return { id: 10, title: 'Did You Know: Why New Construction Homes Are A Top Choice For Today\'s Home Buyer', subtitle: null, path: '/2021/7/28/did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer/', body: '<p>Are you in the market for a new house? If so, you may have been comparing your options when it comes to open listings on the local market. One decision you will need to consider: do you want to purchase an existing home or build a new one? Let\'s explore a few reasons why new construction homes are a popular choice for today\'s home buyer.</p>\n<h3>A Home Designed (By You) With The Future In Mind</h3>\n<p>Ask anyone who has recently invested in a brand-new home, and many will share that all of the built-in technology was an essential factor. Today\'s homes are designed with the future in mind. High-speed networking, better wireless connectivity, high-tech security and other features are all benefits that typically can\'t be found in older homes.</p>\n<p>Of course, don\'t forget that you play a role in the design choices in a new construction home. It is your chance to design all of the features you would want in a dream house.</p>\n<h3>Energy And Cost Efficient</h3>\n<p>As you might imagine, homes constructed with modern designs and materials are vastly more energy than older homes. Tighter seals, better insulation and more efficient heating and cooling all translate to lower utility costs. Moreover, while the savings per day might seem small, over time, they add up. Leaving more money in your pocket for investment, saving or other purposes.</p>\n<p>If you want to take it a step further, you may even decide to expand your new construction home with solar panels or other high-efficiency upgrades.</p>\n<h3>Less Maintenance Means More Free Time</h3>\n<p>Finally, you can sleep soundly knowing that a new construction home needs far less maintenance work than an older home. Of course, there will still be the occasional job that needs taking care of. So you will want to be diligent in fixing up any damage or issues that do occur so that the problem does not spread. But overall, you can expect to spend less of your free time repairing things and more of it relaxing and enjoying life.</p>\n<p>These are just a few of the many great reasons to invest in a brand-new home. To learn more about new construction real estate opportunities in the local area, contact us today. Our professional team is happy to discuss your needs and help you find the perfect new home.</p>\n', image_filename: '/img/banner-insights.485d25f7.jpg' }
        // } else if (this.slug === '3-ways-that-a-reverse-mortgage-can-transform-your-retirement') {
        //   return { id: 9, title: '3 Ways That a Reverse Mortgage Can Transform Your Retirement', subtitle: null, path: '/2021/7/28/3-ways-that-a-reverse-mortgage-can-transform-your-retirement/', body: '<p>Are you a retired individual looking for ways to increase your financial security? If so, you may have heard of a home equity conversion mortgage, more commonly known as a reverse mortgage. Used correctly, this is one of the most effective financial products for retirees who own their home.</p>\n<p>Let\'s explore three ways that a reverse mortgage can help to transform a dull retirement into one filled with excitement.</p>\n<h3>It\'s All About Flexibility</h3>\n<p>The primary benefit that one receives with a reverse mortgage is financial flexibility. It is an excellent way to tap into the equity that has built up in your home over time without having to sell the house and move out. Moreover, unlike a traditional home loan, the payment terms are far more flexible. In many cases, payments are not required until you are ready to leave the home permanently.</p>\n<h3>An Extra Source Of Income</h3>\n<p>Is your lifestyle starting to suffer because you do not have a regular salary coming in for you and your partner? Regardless of how much you have saved in 401-k and other retirement accounts, losing that regular monthly income can be depressing.</p>\n<p>The good news: a reverse mortgage can help to change that. The funds you receive can be used however you want. You can invest in renovations for your home, take a nice vacation, invest in the stock market or simply leave it in your bank account. It is a helpful \'bridge\' income source that will ensure that you have no trouble taking care of life\'s many expenses.</p>\n<h3>A Contingency Fund, Just \'In Case\'</h3>\n<p>Finally, a reverse mortgage or home equity conversion mortgage can be an excellent contingency fund. If you take this out as a line of credit, the money will be available if and when they are needed. Many retired individuals lack a financial \'safety net\' and end up suffering due to unexpected health or other costs. With a reverse mortgage, you can sleep soundly knowing that emergency cash is there if needed.</p>\n<p>As you can see, taking advantage of a reverse mortgage can be the catalyst that helps take your retirement to the next level. To learn more about these unique financial products, contact our professional mortgage team today. We are happy to share how a reverse mortgage can benefit you and your family.</p>\n', image_filename: '/img/banner-partner.b6026520.jpg' }
        // } else if (this.slug === '3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes') {
        //   return { id: 8, title: '3 Key Ways That Driverless Cars Are Going to Reshape How We Design and Use Our Homes', subtitle: null, path: '/2021/7/28/3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes/', body: '<p>Are you ready for the coming shift to driverless cars? While it might seem like some sort of futuristic vision, the truth is that driverless vehicles will be on the road within a few short years. Let\'s explore three key ways that driverless cars are going to help to shape how we think about our homes in the very near future.</p>\n<h3>#1: Goodbye, Garages</h3>\n<p>It might seem a bit strange to think about now, but many people are likely to get rid of their cars entirely. Car ownership is expected to shift to entrepreneurs and services who offer vehicles for on-demand use. We are already starting to see this transition take place, especially with city dwellers who are getting used to Uber, Lyft and other ride-sharing services. So, if you do not own a car, having a garage attached to your house does not make much sense.</p>\n<p>Consider the many uses that a family can get from the space currently occupied by a garage full of cars. Your house footprint can be that much bigger, or you can convert that area into more yard space.</p>\n<h3>#2: Get Used To Smaller Streets And More Efficient Land Use</h3>\n<p>The second significant change you are going to see is a complete re-imagining of how we design and use our streets. Fewer people will own cars that need to be parked along the side of the street. Also, self-driving cars can move elsewhere for storage when they\'re not needed. This combination will allow city planners to thin streets, freeing up land use for bike lanes, boulevards or larger yard areas. If you are the type that enjoys having a beautiful big front lawn, the coming shift to driverless cars will benefit you.</p>\n<h3>#3: More Space Means More Green Space</h3>\n<p>Finally, expect to see a lot more green space around your house in the future. You will have more space for landscaping, flower beds, gardens, trees and other yard fixtures. Even if you do end up owning a driverless car in the future, it\'s likely to be electric. The most substantial commitment you will need to make is either a charging plug and wall fixture or a large ground pad that the car sits on when it needs to top off the batteries.</p>\n<p>There are few who doubt that driverless cars are going to cause a major shift in how we live, work and move from place to place. If you\'re looking to take advantage of this shift when you buy your next home, contact us. Our team of real estate professionals will be happy to share excellent home listings that will be perfect for those looking to change how they use their car.</p>\n', image_filename: '/img/banner-forecast.34fcf90b.jpg' }
        // } else if (this.slug === '5-things-to-consider-when-purchasing-your-first-home') {
        //   return { id: 1, title: '5 things to consider when purchasing your first home', subtitle: null, path: '/2021/5/2/5-things-to-consider-when-purchasing-your-first-home/', body: '<p>Taking the first step onto the property ladder is one of the biggest moments in anyone’s life.\nBuying a home is more than a purchase, it’s a major investment, almost certainly the biggest at\nthat point in the buyer’s life.</p>\n<p>Being aware of the pitfalls around every corner is key to being able to avoid them. Learning\nabout the best practices for budgeting and financing options will allow you to put your best\nfoot forward and make the right purchase for both now and your future.</p>\n<h3>How much can you actually afford to pay?</h3>\n<p>It’s recommended that home buyers keep their house payments to less than 25% of their income.\nThis is not a hard and fast rule, exceptions will occur. For example, if you are already carrying\nstudent, or other forms of debt, it would be wiser to consider a lower percentage of income.</p>\n<h3>What type of mortgage should you choose?</h3>\n<p>It is crucial to understand which type of mortgage will best suit your needs. The biggest\nchoice is between a fixed rate and an adjustable rate mortgage.</p>\n<p>With a fixed rate mortgage, you have certainty of what your repayments will be. They will not\nvary, offering greater budgetary transparency. However, to mitigate risk for the lender,\ninterest rates typically begin higher and if they fall, your payments won’t follow suit.\nOccasionally, there are also penalties for early repayment.</p>\n<p>On the other hand, adjustable rate mortgages track a fixed economic indicator, most commonly\nthe prevailing interest rate. This means that if interest rates fall, so do your repayments,\nbut you are also exposed to rising costs after an interest rate hike.</p>\n<p>The length of your mortgage is also a huge consideration. The most common mortgage length is\n30 years, but borrowers can opt for shorter or longer loans. A 15-year loan will mean larger\nrepayments, but less interest paid, while a 30-year mortgage means paying less each month but\nover a longer period, meaning more interest.</p>\n<h3>Don’t forget the closing costs!</h3>\n<p>Buying and owning a house comes with all sorts of added expenses. But most importantly, buyers\nmust plan with their closing costs in mind. While many people rightly focus on getting their\ndown payment in order to secure the mortgage, you will have to set some money aside for closing costs.</p>\n<p>It’s wise to earmark 2-5% of the house price for costs including, but not limited to, appraisals,\nhome inspections, mortgage-related fees, property taxes and insurance.</p>\n<h3>Get pre-approved for a loan</h3>\n<p>Considering sellers can often be relying on a quick sale to buy their next home, it’s crucial you appear\nas a serious buyer. Getting pre-qualified for a loan and receiving a preapproval letter from your\nlender is a great way of doing this.</p>\n<p>This will involve providing salary and other financial information to your lender to prove your\ncapability of repaying a loan.</p>\n<h3>Will your home increase over time?</h3>\n<p>Everyone wants their home to be a wise real estate investment. Paying a mortgage means you are spending\nmore than the closing price of your house, so buying a property that will appreciate in value is important.</p>\n<p>But how do you know whether your home will be worth more in the future? That’s where Honely will help.</p>\n<p>Our one-of-a-kind, forward-looking algorithm leverages data science and machine learning capabilities\nto provide future home values. We give home buyers the tools they need to make informed decisions and\ninsight into the results their purchase will yield in the long-term.</p>\n<p>Use the power of data and our industry leading forecasting tools to give you the confidence to make\na great real estate investment.</p>\n', image_filename: '/img/blog-01.6fa1e864.jpg' }
        // } else {
        //   return { id: 8, title: '4 Things You Should Never, Ever Say If You Hope to Sell Your Home', subtitle: null, path: '/2021/7/28/4-things-you-should-never-ever-say-if-you-hope-to-sell-your-home/', body: '<p>Have you ever had a conversation with a total stranger where you said something that you regret? If you are placing your house or condo on the market, you\'re eventually going to end up having to chat with potential buyers. Yes, your real estate agent is likely to do most of the talking. However, you will still have to deal with buyers that want to grill you about the home\'s history, condition and more. With that in mind, let\'s have a look at four things you should never say to someone who is interested in buying your home.</p>\n<h3>"We\'re Not Accepting Offers Less Than..."</h3>\n<p>A good way to kill your sale and have a buyer walk away is to set a price floor on bids and offers. Even if the amount you are asking for is reasonable, many buyers will pass because they are offended that they\'re being forced to bid above a certain price. Unless otherwise advised by your agent, it is best to let buyers feel in control of the offer process. You can always counter-offer later.</p>\n<h3>"Our House Has Been On The Market For..."</h3>\n<p>Stating how long your house has been on the market is rarely a good look. No matter how short or long the listing period has gone on for, buyers don\'t need to know this. Moreover, if your home has been on the market for months, knowing that may scare potential buyers off.</p>\n<h3>"We\'ve Always Meant To Renovate That..."</h3>\n<p>If you were going to fix, improve or even clean something in your home, you probably would have done it before inviting potential buyers in. Your goal is to present the house you do have in the best possible light. Try to avoid pointing out areas that a buyer is going to need to renovate or invest in later.</p>\n<h3>"We Need To Close The Sale By..."</h3>\n<p>The last thing you want to do is look desperate to close the sale and move on. Buyers and their agents are going to be looking for signs of weakness which will allow them to submit low-ball offers for your home. If you let on that you have to sell or move by some deadline, you can rest assured that you are not going to get as much when you sell.</p>\n<p>There you have it – four of the (many) things you should not say to potential buyers of your home. For more tips and advice about selling your home, contact our professional real estate team today. We are happy to help.</p>', image_filename: '' }
        // }
        var firstItem = this.posts.length > 0 ? this.posts[0] : null
        if (firstItem !== null) {
          var year = new Date(firstItem.post_date).getFullYear()
          var month = new Date(firstItem.post_date).getMonth()
          var date = new Date(firstItem.post_date).getDate()
          firstItem.path = `/${year}/${month}/${date}/${firstItem.slug}/`
        }
        return firstItem
        // return this.posts.length > 0 ? this.posts[0] : null
      },
      filteredItems () {
        var filteredItems = []
        if (this.posts.length === 1) {
          var filteredItem = this.posts[0]
          var year = new Date(filteredItem.post_date).getFullYear()
          var month = new Date(filteredItem.post_date).getMonth()
          var date = new Date(filteredItem.post_date).getDate()
          filteredItem.path = `/${year}/${month}/${date}/${filteredItem.slug}/`
          filteredItems.push(filteredItem)
          return filteredItems
        } else {
          filteredItems = this.posts.filter((item, index) => {
            return index > 0 && index < 4
          })
          for (let i = 0; i < filteredItems.length; i++) {
            year = new Date(filteredItems[i].post_date).getFullYear()
            month = new Date(filteredItems[i].post_date).getMonth()
            date = new Date(filteredItems[i].post_date).getDate()
            filteredItems[i].path = `/${year}/${month}/${date}/${filteredItems[i].slug}/`
          }
          return filteredItems
        }
        // if (this.slug === 'did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer') {
        //   return [{ id: 9, title: '3 Ways That a Reverse Mortgage Can Transform Your Retirement', path: '/2021/7/28/3-ways-that-a-reverse-mortgage-can-transform-your-retirement/', post_date: '2021-07-28', image_filename: '/img/banner-partner.b6026520.jpg', truncatedBody: 'Are you a retired individual looking for ways to increase your financial security? If so, you may have heard of a home equity conversion mortgage, more commonly known as a reverse mortgage. Used correctly, this is one of the most effective ..." }, { id: 8, title: "3 Key Ways That Driverless Cars Are Going to Reshape How We Design and Use Our Homes", path: "/2021/7/28/3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes/", post_date: "2021-07-28", image_filename: "/img/banner-forecast.34fcf90b.jpg", truncatedBody: "Are you ready for the coming shift to driverless cars? While it might seem like some sort of futuristic vision, the truth is that driverless vehicles will be on the road within a few short years. Let\'s explore three key ways that driverless ...' }, { id: 1, title: '5 things to consider when purchasing your first home', path: '/2021/5/2/5-things-to-consider-when-purchasing-your-first-home/', post_date: '2021-05-02', image_filename: 'img/blog-01.6fa1e864.jpg', truncatedBody: 'Taking the first step onto the property ladder is one of the biggest moments in anyone’s life. Buying a home is more than a purchase, it’s a major investment, almost certainly the biggest at that point in the buyer’s life. Being aware of ...' }]
        // } else if (this.slug === '3-ways-that-a-reverse-mortgage-can-transform-your-retirement') {
        //   return [{ id: 10, title: 'Did You Know: Why New Construction Homes Are A Top Choice For Today\'s Home Buyer', path: '/2021/7/28/did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer/', post_date: '2021-07-28', image_filename: '/img/banner-insights.485d25f7.jpg', truncatedBody: 'Are you in the market for a new house? If so, you may have been comparing your options when it comes to open listings on the local market. One decision you will need to consider: do you want to purchase an existing home or build a new one? Let\'s ...' }, { id: 8, title: '3 Key Ways That Driverless Cars Are Going to Reshape How We Design and Use Our Homes', path: '/2021/7/28/3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes/', post_date: '2021-07-28', image_filename: '/img/banner-forecast.34fcf90b.jpg', truncatedBody: 'Are you ready for the coming shift to driverless cars? While it might seem like some sort of futuristic vision, the truth is that driverless vehicles will be on the road within a few short years. Let\'s explore three key ways that driverless ...' }, { id: 1, title: '5 things to consider when purchasing your first home', path: '/2021/5/2/5-things-to-consider-when-purchasing-your-first-home/', post_date: '2021-05-02', image_filename: 'img/blog-01.6fa1e864.jpg', truncatedBody: 'Taking the first step onto the property ladder is one of the biggest moments in anyone’s life. Buying a home is more than a purchase, it’s a major investment, almost certainly the biggest at that point in the buyer’s life. Being aware of ...' }]
        // } else if (this.slug === '3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes') {
        //   return [{ id: 10, title: 'Did You Know: Why New Construction Homes Are A Top Choice For Today\'s Home Buyer', path: '/2021/7/28/did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer/', post_date: '2021-07-28', image_filename: '/img/banner-insights.485d25f7.jpg', truncatedBody: 'Are you in the market for a new house? If so, you may have been comparing your options when it comes to open listings on the local market. One decision you will need to consider: do you want to purchase an existing home or build a new one? Let\'s ...' }, { id: 9, title: '3 Ways That a Reverse Mortgage Can Transform Your Retirement', path: '/2021/7/28/3-ways-that-a-reverse-mortgage-can-transform-your-retirement/', post_date: '2021-07-28', image_filename: '/img/banner-partner.b6026520.jpg', truncatedBody: 'Are you a retired individual looking for ways to increase your financial security? If so, you may have heard of a home equity conversion mortgage, more commonly known as a reverse mortgage. Used correctly, this is one of the most effective ...' }, { id: 1, title: '5 things to consider when purchasing your first home', path: '/2021/5/2/5-things-to-consider-when-purchasing-your-first-home/', post_date: '2021-05-02', image_filename: 'img/blog-01.6fa1e864.jpg', truncatedBody: 'Taking the first step onto the property ladder is one of the biggest moments in anyone’s life. Buying a home is more than a purchase, it’s a major investment, almost certainly the biggest at that point in the buyer’s life. Being aware of ...' }]
        // } else if (this.slug === '5-things-to-consider-when-purchasing-your-first-home') {
        //   return [{ id: 10, title: 'Did You Know: Why New Construction Homes Are A Top Choice For Today\'s Home Buyer', path: '/2021/7/28/did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer/', post_date: '2021-07-28', image_filename: '/img/banner-insights.485d25f7.jpg', truncatedBody: 'Are you in the market for a new house? If so, you may have been comparing your options when it comes to open listings on the local market. One decision you will need to consider: do you want to purchase an existing home or build a new one? Let\'s ...' }, { id: 9, title: '3 Ways That a Reverse Mortgage Can Transform Your Retirement', path: '/2021/7/28/3-ways-that-a-reverse-mortgage-can-transform-your-retirement/', post_date: '2021-07-28', image_filename: '/img/banner-partner.b6026520.jpg', truncatedBody: 'Are you a retired individual looking for ways to increase your financial security? If so, you may have heard of a home equity conversion mortgage, more commonly known as a reverse mortgage. Used correctly, this is one of the most effective ...' }, { id: 8, title: '3 Key Ways That Driverless Cars Are Going to Reshape How We Design and Use Our Homes', path: '/2021/7/28/3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes/', post_date: '2021-07-28', image_filename: '/img/banner-forecast.34fcf90b.jpg', truncatedBody: 'Are you ready for the coming shift to driverless cars? While it might seem like some sort of futuristic vision, the truth is that driverless vehicles will be on the road within a few short years. Let\'s explore three key ways that driverless ...' }]
        // } else {
        //   return [{ id: 10, title: 'Did You Know: Why New Construction Homes Are A Top Choice For Today\'s Home Buyer', path: '/2021/7/28/did-you-know--why-new-construction-homes-are-a-top-choice-for-today-s-home-buyer/', post_date: '2021-07-28', image_filename: '/img/banner-insights.485d25f7.jpg', truncatedBody: 'Are you in the market for a new house? If so, you may have been comparing your options when it comes to open listings on the local market. One decision you will need to consider: do you want to purchase an existing home or build a new one? Let\'s ...' }, { id: 9, title: '3 Ways That a Reverse Mortgage Can Transform Your Retirement', path: '/2021/7/28/3-ways-that-a-reverse-mortgage-can-transform-your-retirement/', post_date: '2021-07-28', image_filename: '/img/banner-partner.b6026520.jpg', truncatedBody: 'Are you a retired individual looking for ways to increase your financial security? If so, you may have heard of a home equity conversion mortgage, more commonly known as a reverse mortgage. Used correctly, this is one of the most effective ...' }, { id: 8, title: '3 Key Ways That Driverless Cars Are Going to Reshape How We Design and Use Our Homes', path: '/2021/7/28/3-key-ways-that-driverless-cars-are-going-to-reshape-how-we-design-and-use-our-homes/', post_date: '2021-07-28', image_filename: '/img/banner-forecast.34fcf90b.jpg', truncatedBody: 'Are you ready for the coming shift to driverless cars? While it might seem like some sort of futuristic vision, the truth is that driverless vehicles will be on the road within a few short years. Let\'s explore three key ways that driverless ...' }, { id: 1, title: '5 things to consider when purchasing your first home', path: '/2021/5/2/5-things-to-consider-when-purchasing-your-first-home/', post_date: '2021-05-02', image_filename: 'img/blog-01.6fa1e864.jpg', truncatedBody: 'Taking the first step onto the property ladder is one of the biggest moments in anyone’s life. Buying a home is more than a purchase, it’s a major investment, almost certainly the biggest at that point in the buyer’s life. Being aware of ...' }]
        // }
      },
    },

    watch: {
      $route (to, from) {
        this.year = this.$route.params.year
        this.month = this.$route.params.month
        this.day = this.$route.params.day
        this.slug = this.$route.params.slug
        this.load()
      },
    },

    created () {
      this.year = this.$route.params.year
      this.month = this.$route.params.month
      this.day = this.$route.params.day
      this.slug = this.$route.params.slug
      this.pageUrl = 'https://honely.com/insights/' + this.year + '/' + this.month + '/' + this.day + '/' + this.slug

      if (this.$useDevVariables) {
        this.title = this.firstItem.title
        this.subtitle = this.firstItem.subtitle
        this.image = require('@/assets/' + this.firstItem.image)
        this.body = this.firstItem.body
      } else {
        this.load()
      }
    },

    methods: {
      printme: function (event) {
        window.print()
      },
      load () {
        this.loading = true
        if (this.year && this.month && this.day && this.slug) {
          // axios.get('/api/v1/post/' + this.year + '/' + this.month + '/' + this.day + '/' + this.slug + '/', {
          axios.get('https://api.honely.com/lookup/blog_posts_finder?slug=' + this.slug, {

          }).then((response) => {
            var words = response.data.title.split(' ')
            this.title = (words.map((word) => { return word[0].toUpperCase() + word.substring(1) }).join(' '))
            this.subtitle = response.data.subtitle
            this.body = response.data.body
            if (response.data.image_filename) {
              this.image = require('@/assets/' + response.data.image_filename)
            } else {
              this.image = require('@/assets/blog-01.jpg')
            }
            // this.image = require('@/assets/temp-banner-insights.jpg')
            this.loading = false
          })
            .catch((error) => {
              console.warn(error.response.status)
              console.warn(error)

              this.loading = false
              return null
            })
        }

        this.$store.dispatch('insights/getTargetPost', { slug: this.slug })
      },
    },
  }
</script>

<style lang="sass">
#hero-alt
  // height: 425px
  height: 425px
  font-family: $heading-font-family

  .page-subheader
    padding: 0
    font-family: $body-font-family
    font-size: 20px
    color: white
    max-width: 800px
    height: auto

  .header-container
    max-width: 1185px

#post
  color: $color-gray-dk

  .blog-body
    span
      p:first-child
        font-size: 30px !important
        line-height: 38px !important
        font-weight: 700
        color: $color-gray-mddk
        margin-bottom: 30px

  p.post-footer
    font-size: 12px
    font-weight: 700
    line-height: 17px
    border-top: 2px solid $color-gray-vlt
    color: $color-gray-med

  h3
    margin-bottom: 5px

  .post-sidebar
    position: relative
    // height: 125px
    // padding-left: 25px

    .social-container
      position: relative
      border-bottom: 2px solid $color-gray-vlt
      height: 90px
      margin-bottom: 20px

  .insight-content
    overflow: hidden

  .insight-content .v-card__subtitle
    color: $color-gray-med
    font-size: 15px
    line-height: 17px
    padding-bottom: 8px

  .insight-content .v-card__title
    font-family: $heading-font-family
    font-weight: normal
    font-size: 18px
    line-height: 25px
    word-break: normal
    padding-top: 0

  .standard-insight .v-image
    border-radius: 5px 5px 0 0

  .recent-posts-container
      display: flex
      overflow-y: scroll
  .recent-posts
    .v-card
      background-color: white
      border-color: white
      min-height: 320px !important

      .v-card__title
        color: black

      .v-image
        height: 150px !important

  .v-speed-dial--left
    left: 60px !important

  .btn-printer
    margin-top: 15px

</style>

<style lang="css">

@media (max-width: 1264px) {
  #hero-alt .header-container {
    max-width: 900px;
  }
}

@media (max-width: 960px) {
  #hero-alt {
    height: auto;
  }
  #hero-alt h1.text-h4{
    font-size: 20px !important;
    line-height: 23px !important;
  }
  #post .blog-body span p:first-child {
    font-size: 23px !important;
    line-height: 28px !important;
  }
}

@media (max-width: 768px) {
  .recent-posts-container{
    flex-direction: column;
  }
}
</style>
